module.exports = __webpack_public_path__ + "static/container-carrier-def63e27a9ed6fa4631254000a4ee393.png";